<template>
    <b-modal ref="mdlAccettazioneBox" size="xl" no-close-on-backdrop no-close-on-select title="Accettazione Box" hide-footer>
        <div class="modal-body">
            <div v-if="step === 0">
                <rsa-accettazione-edit-component :id="idAccettazione" ref="cmpRsaAccettazioneEdit" @update="onUpdateJsonData" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" :key="componentKey"></rsa-accettazione-edit-component>
            </div>
            <div v-if="step === 1">
                <b-table :busy="isBusy" sticky-header ref="table" stacked="lg" striped hover :items="listaBox" :fields="fields" :current-page="1" :per-page="100000" sort-icon-left head-variant="light" class="sa-b-table" selectable select-mode="single" @row-selected="onRowSelectedFarmaco"> </b-table>
            </div>
        </div>
        <hr />
        <b-row>
            <div class="sa-padding-right text-right col">
                <b-button type="button" variant="secondary" @click="onCancel">{{ this.$i18n.t("global.lblBtnCancel") }}</b-button>
                <b-button v-if="step === 0" type="button" variant="primary" @click="onSave">{{ this.$i18n.t("global.lblBtnSave") }}</b-button>
                <b-button v-if="step === 1" type="button" variant="primary" @click="onSaveBox">{{ this.$i18n.t("global.lblBtnSave") }}</b-button>
            </div>
        </b-row>
        <sa-modal-loading ref="mdlSaModalLoading"></sa-modal-loading>
    </b-modal>
</template>

<script>
// import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../utility/UtilityMixin";
import RsaAccettazioneEditComponent from "../../rsa/rsaaccettazione/components/RsaAccettazioneEditComponent.vue";
import { SaModalLoading } from "../../utility";
// import moment from "moment";
export default {
    mixins: [UtilityMixin],
    components: { SaModalLoading, RsaAccettazioneEditComponent }, //DatePicker,

    data() {
        return {
            pathResourceAgendaAppuntamenti: "/agendaappuntamenti",
            pathResourceAccettazione: "/rsaaccettazioni",
            pathResourceBox: "/agendebox",
            pathResourceBoxAccettazione: "/agendeboxaccettazione",
            jsonDataAppuntamento: {},
            idAccettazione: "-1",
            componentKey: 0,
            jsonDataAccettazione: {
                codiceStruttura: null, //non a video
                idPresidio: null, //non a video
                numero: "", //non a video
                note: null, //non a video
                regime: null, //non a video
                settingCodice: null,
                settingDescrizione: "",
                idPrenotazione: null, //non a video
                /* nonAutonomo: null, */
                /* decretoInvalidita: null,
                strutturaProvenienza: null,
                titoloStudio: null,
                documentoTipo: null,
                documentoNumero: "",
                documentoDataRilascio: null,
                documentoDataScadenza: null, */
                accettazioneStruttura: {}, //non a video
                accettazioneAnagrafica: {
                    idAccettazione: null, //non a video
                    tipo: null, //non a video
                    identificativo: null,
                    tipoIdentificativo: "CF", //non a video
                    cognome: null,
                    nome: null,
                    dataNascita: null,
                    provinciaNascita: null,
                    comuneNascitaCodiceIstat: null,
                    sesso: null,
                    regioneResidenza: null,
                    provinciaResidenza: null,
                    comuneResidenzaCodiceIstat: null,
                    indirizzoResidenza: null,
                    capResidenza: null,
                    regioneDomicilio: null,
                    provinciaDomicilio: null,
                    comuneDomicilioCodiceIstat: null,
                    indirizzoDomicilio: null,
                    capDomicilio: null,
                    note: null,
                    medicoCurante: "",
                    codiceFiscaleMedicoCurante: null, //non a video
                    telefono: "",
                    email: "",
                    emailMedicoCurante: "",
                    medicoCuranteTelefono: "",
                    provenienzaPaziente: null,
                    tipologiaPaziente: null,
                },

                accettazioneStati: [],
                accettazionePrestazioni: [],
                accettazioniAsl: { aslDomicilioAmbito: null, aslResidenzaAmbito: null },
            },
            fields: [
                {
                    label: "Nome Box",
                    key: "nome",
                    sortable: true,
                },
            ],
            isBusy: false,
            jsonDataBox: { idAppuntamento: null, idAccettazione: null, idBox: null, dataOra: null },
            listaBox: [],
            step: 0,
        };
    },
    methods: {
        init(appuntamento) {
            let me = this;
            me.jsonDataAccettazione = {
                codiceStruttura: null, //non a video
                idPresidio: null, //non a video
                numero: "", //non a video
                note: null, //non a video
                regime: null, //non a video
                settingCodice: null,
                settingDescrizione: "",
                idPrenotazione: null, //non a video
                /* nonAutonomo: null, */
                /* decretoInvalidita: null,
                strutturaProvenienza: null,
                titoloStudio: null,
                documentoTipo: null,
                documentoNumero: "",
                documentoDataRilascio: null,
                documentoDataScadenza: null, */
                accettazioneStruttura: {}, //non a video
                accettazioneAnagrafica: {
                    idAccettazione: null, //non a video
                    tipo: null, //non a video
                    identificativo: null,
                    tipoIdentificativo: "CF", //non a video
                    cognome: null,
                    nome: null,
                    dataNascita: null,
                    provinciaNascita: null,
                    comuneNascitaCodiceIstat: null,
                    sesso: null,
                    regioneResidenza: null,
                    provinciaResidenza: null,
                    comuneResidenzaCodiceIstat: null,
                    indirizzoResidenza: null,
                    capResidenza: null,
                    regioneDomicilio: null,
                    provinciaDomicilio: null,
                    comuneDomicilioCodiceIstat: null,
                    indirizzoDomicilio: null,
                    capDomicilio: null,
                    note: null,
                    medicoCurante: "",
                    codiceFiscaleMedicoCurante: null, //non a video
                    telefono: "",
                    email: "",
                    emailMedicoCurante: "",
                    medicoCuranteTelefono: "",
                    provenienzaPaziente: null,
                    tipologiaPaziente: null,
                },
            };
            me.jsonDataAppuntamento = appuntamento;
            if (me.jsonDataAppuntamento.tipoIdentificativo === "CF") {
                let path = me.pathResourceAccettazione + "/identificativo/" + me.jsonDataAppuntamento.identificativoAppuntamento;
                UtilityMixin.methods.loadDataResources(path + "", me.filtro, me.loadDataSuccess, me.loadDataError);
            } else {
                me.jsonDataAccettazione.accettazioneAnagrafica.nome = me.jsonDataAppuntamento.nome;
                me.jsonDataAccettazione.accettazioneAnagrafica.cognome = me.jsonDataAppuntamento.cognome;
                me.jsonDataAccettazione.accettazioneAnagrafica.telefono = me.jsonDataAppuntamento.identificativoAppuntamento;
                RsaAccettazioneEditComponent.methods.initAccettazione(me.jsonDataAccettazione);
                me.componentKey++;
                me.$refs.mdlAccettazioneBox.show();

                // me.$refs.cmpRsaAccettazioneEdit.initAccettazione(me.jsonDataAccettazione);
            }

            // me.$refs.mdlAccettazioneBox.show();
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonDataAccettazione = response.data.data;
            me.jsonDataBox.idAccettazione = me.jsonDataAccettazione.id;
            me.jsonDataBox.idAppuntamento = me.jsonDataAppuntamento.id;
            me.jsonDataBox.dataOra = me.jsonDataAppuntamento.dataOraInizio;
            me.step = 1;
            me.loadBox();
            me.$refs.mdlAccettazioneBox.show();
        },
        loadDataError(response) {
            let me = this;
            console.log(response);
            me.jsonDataAccettazione.accettazioneAnagrafica.nome = me.jsonDataAppuntamento.nome;
            me.jsonDataAccettazione.accettazioneAnagrafica.cognome = me.jsonDataAppuntamento.cognome;
            me.jsonDataAccettazione.accettazioneAnagrafica.identificativo = me.jsonDataAppuntamento.identificativoAppuntamento;
            RsaAccettazioneEditComponent.methods.initAccettazione(me.jsonDataAccettazione);
            me.componentKey++;
            me.$refs.mdlAccettazioneBox.show();
        },
        checkAccettazione() {},
        onCancel() {
            this.$refs.mdlAccettazioneBox.hide();
        },
        // show(objectAppuntamento) {
        //     this.objectAppuntamento = objectAppuntamento;
        //     this.$refs.mdlAgendaNuovoAppuntamentoModalComponent.show();
        // },

        onSave() {
            let me = this;
            me.$refs.mdlSaModalLoading.show();
            UtilityMixin.methods.saveResource(me.pathResourceAccettazione, me.jsonDataAccettazione, me.saveSucessResponse, me.saveErrorResponse);
        },
        saveSucessResponse(response) {
            let me = this;
            console.log(response);
            me.$refs.mdlSaModalLoading.close();
            me.jsonDataBox.idAccettazione = response.data.data.id;
            me.jsonDataBox.idAppuntamento = me.jsonDataAppuntamento.id;
            me.jsonDataBox.dataOra = me.jsonDataAppuntamento.dataOraInizio;
            me.loadBox();
            me.step = 1;
        },
        saveErrorResponse(error) {
            console.log(error);
            let me = this;
            if (error.response.status === 400) {
                this.$bvToast.toast("Errore: " + error.response.data.messaggio, {
                    title: "",
                    variant: "danger",
                    solid: true,
                });
                this.$emit("errorRestCall", error);
                me.$refs.mdlSaModalLoading.close();
            } else {
                this.$bvToast.toast("Errore nel salvare i dati del Piano: " + error.message, {
                    title: "",
                    variant: "danger",
                    solid: true,
                });
                me.$refs.mdlSaModalLoading.close();
            }
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            // me.id = data.id;
            me.showModalLoading = false;
        },
        onUpdateJsonData(data) {
            let me = this;
            me.jsonDataAccettazione = data;
        },
        loadBox() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceBox, null, me.loadDataBoxSuccess, me.loadDataBoxError);
        },
        loadDataBoxSuccess(response) {
            let me = this;
            me.rows = response.data.data.list.length;
            me.listaBox = response.data.data.list;
        },
        loadDataBoxError(error) {
            console.log(error);
        },
        onRowSelectedFarmaco(item) {
            let me = this;
            if (item.length > 0) {
                me.jsonDataBox.idBox = item[0].id;
            }
        },
        onSaveBox() {
            let me = this;
            console.log(me.jsonDataBox);
            me.$refs.mdlSaModalLoading.show();
            UtilityMixin.methods.saveResource(me.pathResourceBoxAccettazione, me.jsonDataBox, me.saveBoxSucessResponse, me.saveBoxErrorResponse);
        },
        saveBoxSucessResponse(response) {
            this.$refs.mdlAccettazioneBox.hide();
            this.$emit("saveDateSuccess", response);
            this.$router.push("/agendabox/");
        },
        saveBoxErrorResponse(response) {
            if (response.response.status === 400) {
                this.$emit("errorRestCall", response);
            } else {
                this.$bvToast.toast("Errore nel salvarei dati del Piano: " + response.message, {
                    title: "",
                    variant: "danger",
                    solid: true,
                });
            }
        },
    },
};
</script>

<style></style>
